module.exports = "/_next/static/images/gift-card-8b04180cb35bc89a18991fd66b7a837d.jpg";